export class LogMessage
{
    public static TYPE_USER: number         = 1;
    public static TYPE_SYSTEM: number       = 2;
    public static TYPE_ERROR: number        = 3;
    public static TYPE_UPLOAD: number       = 4;
    public static TYPE_SPECERROR: number    = 5;

    timestamp!: number;
    user!: string;
    message!: string;
    messageType!: number;
}